export function validatePasswordComplexity(password: string = '') {
    if(password.length < 8) {
        return 'Password must be at least 8 characters';
    }

    return '';
}
